import { render, staticRenderFns } from "./ScenarioPermission.vue?vue&type=template&id=0b667ecb&scoped=true&"
import script from "./ScenarioPermission.vue?vue&type=script&lang=js&"
export * from "./ScenarioPermission.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioPermission.vue?vue&type=style&index=0&id=0b667ecb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b667ecb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VForm,
  VIcon,
  VSelect,
  VTextField,
})
